import Config from '@/config';
import http, { HttpPromise } from './http';

export default {
  login: async (params: { login: string; password: string }): Promise<HttpPromise> => {
    const data = new FormData();

    data.append('login', params.login);
    data.append('password', params.password);

    return http.post(
      `${Config.apiHost}/auth/`,
      data,
      {
        headers: {
          skipRenew: true,
        },
      },
    );
  },
  updateTokens: async (params: { refresh: string }): Promise<HttpPromise> => {
    const data = new FormData();

    data.append('refresh', params.refresh);

    return http.post(
      `${Config.apiHost}/auth/update-tokens/`,
      data,
      {
        headers: {
          skipRenew: true,
        },
      },
    );
  },
};
